<h1 mat-dialog-title style="text-align: center">{{ DialogTitle }}</h1>
<div mat-dialog-content style="text-align: center">
    {{ DialogDescription }}
    <div class="row-container">
        <div class="row-label">
            Is Mandatory?
        </div>
        <div class="row-item">
            {{field.IsMandatory }}
        </div>
    </div>
    <div class="row-container">
        <div class="row-label">
            Help Text
        </div>
        <div class="row-item">
            {{field.HelpText}}
        </div>
    </div>
    <div class="row-container">
        <div class="row-label">
            Is Always Hidden
        </div>
        <div class="row-item">
            {{field.IsAlwaysHidden}}
        </div>
    </div>
    <div class="row-container">
        <div class="row-label">
            Is Custom Field
        </div>
        <div class="row-item">
            {{field.IsCustomField}}
        </div>
    </div>
    <div class="row-container">
        <div class="row-label">
            Group Name
        </div>
        <div class="row-item">
            {{field.GroupName}}
        </div>
    </div>
    <div class="row-container">
        <div class="row-label">
            Visibility When Rules
        </div>
        <div class="row-item">
            @for (rule of field.VisibleWhenRules; track rule) {
                <div>
                    {{rule.PropertyName | prettify}}
                    =
                    {{(rule.ValueIs.Value ?? rule.ValueIs.Identifier) | prettify}}
                </div>
            }
        </div>
    </div>
    <div class="row-container">
        <div class="row-label">
            Visibility When OR Rules
        </div>
        <div class="row-item">
            @for (rule of field.VisibleWhenOrRules; track rule) {
                <div>
                    {{rule.PropertyName | prettify}}
                    =
                    {{(rule.ValueIs.Value ?? rule.ValueIs.Identifier) | prettify}}
                </div>
            }
        </div>
    </div>
    <div class="row-container">
        <div class="row-label">
            Mandatory When Rules
        </div>
        <div class="row-item">
            @for (rule of field.MandatoryWhenRules; track rule) {
                <div>
                    {{rule.PropertyName | prettify}}
                    =
                    {{(rule.ValueIs.Value ?? rule.ValueIs.Identifier) | prettify}}
                </div>
            }
        </div>
    </div>
    <div class="row-container">
        <div class="row-label">
            Mandatory When OR Rules
        </div>
        <div class="row-item">
            @for (rule of field.MandatoryWhenOrRules; track rule) {
                <div>
                    {{rule.PropertyName  | prettify}}
                    =
                    {{(rule.ValueIs.Value ?? rule.ValueIs.Identifier) | prettify}}
                </div>
            }
        </div>
    </div>
    <div class="row-container">
        <div class="row-label">
            Hide When Rules
        </div>
        <div class="row-item">
            @for (rule of field.HideWhenRules; track rule) {
                <div>
                    {{rule.PropertyName  | prettify}}
                    =
                    {{(rule.ValueIs.Value ?? rule.ValueIs.Identifier) | prettify}}
                </div>
            }
        </div>
    </div>
    <div class="row-container">
        <div class="row-label">
            Hide When OR Rules
        </div>
        <div class="row-item">
            @for (rule of field.HideWhenOrRules; track rule) {
                <div>
                    {{rule.PropertyName  | prettify}}
                    =
                    {{(rule.ValueIs.Value ?? rule.ValueIs.Identifier) | prettify}}
                </div>
            }
        </div>
    </div>
    <div class="row-container">
        <div class="row-label">
            Hide On UDQ
        </div>
        <div class="row-item">
            <div>
                {{field.HideOnUdq}}
            </div>
        </div>
    </div>
    <div class="row-container">
        <div class="row-label">
            Cascase Changes to Linked Records
        </div>
        <div class="row-item">
            <div>
                {{field.CascadeChanges}}
            </div>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button class="mat-warn" style="margin: 5px" (click)="closeDialog()">{{ DialogConfirmButtonText }}</button>
</div>
